import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import * as Sentry from '@sentry/react';

import { i18n } from '@percent/grants-nomination-form/i18n/config';
import { ErrorFallback } from './ErrorFallback';
import { PostHogProvider } from './PostHogProvider/PostHogProvider';
import { ClientContextController } from '@percent/grants-nomination-form/context/client/clientContextController/ClientContextController';
import { PropsWithChildren } from 'react';
import { CountriesContextController } from '../context/countries/CountriesContextController';

export const AppProviders = ({ children }: PropsWithChildren) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <PostHogProvider>
      <I18nextProvider i18n={i18n}>
        <Router>
          <ClientContextController>
            <CountriesContextController>{children}</CountriesContextController>
          </ClientContextController>
        </Router>
      </I18nextProvider>
    </PostHogProvider>
  </Sentry.ErrorBoundary>
);
